<template>
  <transition mode="out-in" name="fade">
    <div v-if="showCurrentPrice" key="currentPrice">
      <p class="headings--h4">
        {{ I18n.t("internet_auctions.current_price") }}
      </p>
      <p class="price--current">
        {{ I18n.t("artworks.price", { price: formatPrice(internetAuction.value) }) }}
        <span>
          ({{ I18n.t("internet_auctions.auction.number_of_offers", { count: internetAuction.bidsCount }) }})
        </span>
      </p>
    </div>
    <div v-else-if="internetAuctionSold" key="soldPrice">
      <p class="headings--h4 price--highlight">
        {{ I18n.t("artworks.sold_for_label") }}
      </p>
      <p class="price--highlight">
        {{ I18n.t("artworks.price", { price: formatPrice(internetAuction.value) }) }}
      </p>
    </div>
    <div v-else-if="internetAuctionUnsold" key="unsold">
      <p class="headings--h4 mb-3">
        {{ I18n.t("internet_auctions.auction.unsold") }}
      </p>
    </div>
  </transition>
</template>

<script>
  import { mapState } from 'vuex';
  import { formatNumber } from '@/shared/helpers';
  import { INTERNET_AUCTIONS_STATES, AUCTION_STARTED_STATE } from '@/internet_auctions/consts';

  export default {
    name: 'ArtworkState',
    props: {
      internetAuction: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        formatPrice: formatNumber,
      };
    },
    computed: {
      ...mapState(['userId']),
      auctionStateIsStarted() {
        return this.internetAuction.state === AUCTION_STARTED_STATE;
      },
      showCurrentPrice() {
        return (this.internetAuction.bidsCount > 0
                && this.auctionStateIsStarted);
      },
      internetAuctionSold() {
        return this.internetAuction.state === INTERNET_AUCTIONS_STATES.SOLD;
      },
      internetAuctionUnsold() {
        return this.internetAuction.state === INTERNET_AUCTIONS_STATES.UNSOLD;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/internet_auctions/components/artwork/artwork_state.vue?aca3d664